// extracted by mini-css-extract-plugin
export default {"page-section":"XSA2U9","pageSection":"XSA2U9","xs":"NcA2YF"};